<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { versionApi } from '@/api/version'
import appConfig from '@/config/appConfig'

export default {
  name: 'App',
  mounted() {
    // Fetch latest version info from backend
    this.fetchVersionInfo()
  },
  methods: {
    async fetchVersionInfo() {
      try {
        const response = await versionApi.getLatestVersion()
        
        // Backend returns data directly on 200 OK (no status/data wrapper)
        if (response && response.version) {
          appConfig.setVersionConfig(response)
          console.log('Version info updated:', response.version)
        } else {
          appConfig.setVersionError('获取版本信息失败')
          console.error('Version API error: invalid response format')
        }
      } catch (error) {
        // Network or other error
        appConfig.setVersionError('网络错误，无法获取版本信息')
        console.error('Failed to fetch version info:', error)
      }
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  margin: 0;
  padding: 0;
}
</style>